// @flow
import React from 'react'

// types
import AppContainer from './AppContainer'

// store
import createStore from '../store/createStore'

type Props = {
  isBackoffice?: boolean,
}

export default class ConnectorContainer extends React.Component<Props> {
  app = React.createRef()

  static defaultProps = {
    isBackOffice: false,
  }

  shouldComponentUpdate(nextProps) {
    return this.props.activeSettings !== nextProps.activeSettings
  }

  getData = () => {
    return this.app.current.store.getState()
  }

  render() {
    const store = createStore({})
    return <AppContainer ref={this.app} store={store} {...this.props} />
  }
}
